import { echartSetOption } from '../echarts-utils';

const doughnutRoundedChartInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const $chartEl = document.querySelector(
    '.echart-doughnut-rounded-chart-example'
  );

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);
    const getDefaultOptions = () => ({
      legend: {
        orient: 'vertical',
        left: 'left',
        top: 'top',
        itemGap: 10,
        textStyle: {
          color: getColor('text-color-body-tertiary')
        }
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '70%'],
          center: window.innerWidth < 530 ? ['65%', '55%'] : ['50%', '55%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: getColor('background-color-body-highlight'),
            borderWidth: 2
          },
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          data: [
            {
              value: 1200,
              name: 'Starter',
              itemStyle: {
                color: getColor('color-primary')
              }
            },
            {
              value: 1000,
              name: 'Basic',
              itemStyle: {
                color: getColor('color-danger')
              }
            },
            {
              value: 800,
              name: 'Optimal',
              itemStyle: {
                color: getColor('color-info')
              }
            },
            {
              value: 600,
              name: 'Business',
              itemStyle: {
                color: getColor('color-success')
              }
            },
            {
              value: 400,
              name: 'Premium',
              itemStyle: {
                color: getColor('color-warning')
              }
            }
          ]
        }
      ],
      tooltip: {
        trigger: 'item',
        padding: [7, 10],
        backgroundColor: getColor('background-color-body-highlight'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-light-emphasis') },
        borderWidth: 1,
        transitionDuration: 0,
        axisPointer: {
          type: 'none'
        }
      }
    });

    const responsiveOptions = {
      xs: {
        series: [
          {
            center: ['65%', '55%']
          }
        ]
      },
      sm: {
        series: [
          {
            center: ['50%', '55%']
          }
        ]
      }
    };

    echartSetOption(chart, userOptions, getDefaultOptions, responsiveOptions);
  }
};

export default doughnutRoundedChartInit;
